import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from "../../Services/translation.service";
import { HelperService } from "../../Services/helper.service";
import { BannersService } from '../../Services/banners.service';
import { Title, Meta } from '@angular/platform-browser';
import { Banner } from '../../models/banner-model';
import { OffersService } from '../../Services/offers.service';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit {
  offers: any;
  word: any;
  city;
  title: string;
  language: string = '';
  banners: Banner[] = [];

  constructor(
    private offersService: OffersService,
    private activatedRoute: ActivatedRoute,
    private bannersService: BannersService,
    private helperService: HelperService,
    private translationService: TranslationService,
    private serviceTitle: Title,
    private serviceMeta: Meta
  ) {
    this.language = this.translationService.language;
    this.word = this.translationService.word;
    this.city = this.helperService.getCity()
  }

  ngOnInit(): void {
    const currentUrl = this.activatedRoute.snapshot['_routerState'].url;
    if (currentUrl.includes("nova_godina")) {
      this.title = "Нова година";
      this.offersService.getCurrentOffers("novaGodina").subscribe(x => this.offers = x);
    } else if (currentUrl.includes("firmeni.partita")) {
      this.title = "Фирмени партита";
      this.offersService.getCurrentOffers("firmenipartita").subscribe(x => this.offers = x);
    } else if (currentUrl.includes("obedno.menu")) {
      this.title = "Обедно меню";
      this.offersService.getCurrentOffers("obednoMenu").subscribe(x => this.offers = x);
    } else if (currentUrl.includes("osmi_dekemvri")) {
      this.title = "Осми декември";
      this.offersService.getCurrentOffers("osmiDekemvri").subscribe(x => this.offers = x);
    } else if (currentUrl.includes("abiturienti-all")) {
      this.title = "Абитуриенти"; // ask nasko for offer name
      this.offersService.getCurrentOffers("abiturenti").subscribe(x => {
        this.offers = x;
        this.serviceTitle.setTitle("Абитуриенти");
      });
    } else if (currentUrl.includes("8mi-mart")) {
      this.title = "8 март"; // ask nasko for offer name
      this.offersService.getCurrentOffers("8miMart").subscribe(x => {
        this.offers = x;
        this.serviceTitle.setTitle("8 март");
      });
    } else if (currentUrl.includes("14ti-fevruari")) {
      this.title = "14 февруари"; // ask nasko for offer name
      this.offersService.getCurrentOffers("14tiFevruari").subscribe(x => {
        this.offers = x;
        this.serviceTitle.setTitle("14 февруари");
      });
    }

    this.bannersService
      .getBannersListingPage("2,4,5,6,7,8,9,10,20,21,24,52")
      .subscribe(x => {
        this.banners = x;
      });

      this.serviceTitle.setTitle("Заведения " + this.word[this.language][`${this.city}`] + " - оферти за " + this.title);
      this.serviceMeta.updateTag({ name: 'description', content: this.word[this.language].seoDescriptionCity1 + this.city + this.word[this.language].seoDescriptionCity2 });
      this.serviceMeta.updateTag({ name: 'keywords', content: this.word[this.language].seoKeywords1 + this.city + this.word[this.language].seoKeywords2 });
      this.serviceMeta.updateTag({ name: 'og:image', content: 'assets/images/zav-ph.png' });
  }

  replaceBigWithMedium(filename: string) {
    return filename.replace("/big/", "/medium/");
  }

  returnCyrilic(lat: string) {
    return this.helperService.toLatin(lat);
  }
}
